const translations = {
    default: {
        en_US: {
            backToProductPage: 'Back to product page',
            backToCart: 'Back to cart',
            backToPreviousStep: 'Back to previous step',
            learnMore: 'Learn more',
            exitTitle: 'ARE YOU SURE YOU WANT TO EXIT?',
            exitSubTitle: 'Your lens selection will not be saved',
            insuranceTitle: 'Do you have vision insurance?',
            applyInsurance: 'Apply insurance',
            skipForNow: 'Skip for now',
            continueEdit: ' Continue editing',
            saveEdit: 'Save and continue shopping',
            discardChanges: 'Discard changes',
            addToBag: 'Add to bag',
            confirmChanges: 'Confirm changes',
            applyingInsurance: 'Applying insurance benefits',
            selectColor: 'Select a color:',
            indoor: 'INDOOR',
            outdoor: 'OUTDOOR',
            add: 'Add',
            showColor: 'Show color options',
            hideColor: 'Hide color options',
            close: 'Close',
            seeTreatment: 'See the treatment',
            seeHowMade: 'See how it’s made',
            continueWatching: 'Continue watching',
            mostPopularChoice: 'Most Popular Choice',
            sidebarOverlayColor: 'rgba(51, 51, 51, 0.6)',
            imageErrorMessage:
                'N.B. Don’t worry if the image doesn’t display the lens color you selected, you will receive it in chosen color.',
            lensErrorMessage: 'This color lens will be added to yout frame',
            steps: {
                type: {
                    title: 'Select your vision need',
                    confirmedTitle: 'Use',
                },
                prescription: {
                    title: 'Complete your prescription',
                    confirmedTitle: 'Prescription',
                },
                brand: {
                    title: 'Choose your lens brand',
                    confirmedTitle: 'Brand',
                },
                thickness: {
                    title: 'Select your lens thickness',
                    confirmedTitle: 'Thickness',
                },
                treatments: {
                    title: 'Complete your lens',
                    gvpTitle: 'Complete your Great Value Package',
                    confirmedTitle: 'Treatments',
                    alreadyIncluded: 'Already included with your lens',
                    noTreatments: 'Continue without extra treatments',
                    selectTreatmentInsurance: 'Select treatment to see your benefits applied',
                    applyAndContinue: 'Apply & Continue',
                    continue: 'Continue',
                    polar: {
                        title: 'Polarized',
                    },
                    antiReflective: {
                        title: 'Anti-reflective treatment',
                    },
                    blueLight: {
                        title: 'Blue light treatment',
                    },
                    transition: {
                        title: 'Light responsive treatment',
                        blueLightIncluded: 'Two glasses in one, with blue light treatment included',
                    },
                    colorCategory: {
                        title: 'Select a color',
                    },
                    extraTreatments: {
                        uvProtection: {
                            title: 'UV protection & scratch-resistant',
                            imageFileName: 'treatment-uv-scratch',
                            imageFileNameSun: 'treatment-uv-scratch-sun',
                        },
                        antiScratch: {
                            title: 'Scratch-resistant',
                            imageFileName: 'treatment-scratch',
                            imageFileNameSun: 'treatment-scratch-sun',
                        },
                    },
                },
                warranty: {
                    title: 'Add LensCrafters Care Coverage',
                    oneYear: 'One-year coverage',
                    twoYear: 'Two-year coverage',
                },
            },
            insurance: {
                copy: {
                    inactive: 'Add insurance benefits',
                    active: 'Insurance benefits applied',
                },
            },
            price: {
                frame: 'Frame price: ',
                frameLens: 'Frame + Lenses price: ',
                gvp: 'Great Value Package',
                startingAt: 'Starting at ',
                completePair: 'Complete pair ',
                completePairAt: 'Complete pair at ',
                totalFrameLens: 'Total (frame + lenses):',
                free: 'Free',
            },
            stepAnalyticsName: [
                'Type',
                'Prescription',
                'Brand',
                'Material',
                'Treatments',
                'Review',
            ],
            prescription: {
                toggleLabel:
                    'Add your prescription values, we’ll help you find the perfect lens for your vision needs.',
                prescriptionTitle:
                    'Add your prescription values, we’ll show you the perfect lens for your vision needs.',
                readPrescription: 'How to read your prescription',
                addLabel: 'I also have an ADD value',
                applyButton: 'Apply & continue',
                submitButton: 'Submit',
                clearButton: 'Clear all',
                skipButton: 'Skip for now',
                compatibleFramesButton: 'Shop compatible frames',
                doctorDetails:
                    "We'll ask for a copy of your prescription or doctor's details during or after checkout",
                missingValueError: 'Add your values to continue',
                positiveNegativeError:
                    "You've entered 1 positive value and 1 negative value, which is quite rare. We suggest double checking your prescription.",
                compatibleFrameError:
                    "Sorry! The frame you've chosen isn't compatible with your prescription.",
                compatibleFrameSubLabel: "But don't worry, compatible frames are available.",
                axisError: "The AXIS values you've inserted are not correct!",
                axisSubError: 'These values must be between 0 and 180.',
                axisSubErrorZero: 'If CYL value is higher or lower than 0, AXIS values can’t be 0.',
                editLabel: 'Edit prescription',
                pdHelp: 'What is this?',
                twoPDNumbers: 'I have two PD values',
                missingInputMessage:
                    "Add your missing values to complete the upload of your prescription and we'll recommend the most suitable lens.",
                defaultInputMessage:
                    "Add your SPH and CYL values and we'll recommend the most suitable lens for your vision needs.",
                skipMessage: "We'll ask you to complete or upload your prescription later",
                readyMessage: 'We are now able to suggest the right lens for you!',
                bestPrescription: 'Best for your prescription',
                proceedCheckbox:
                    'By clicking this box, I confirm that the prescription values entered above are taken from a unexpired written prescription issued to me, signed by a licensed optometrist or ophthalmologist.',
                proceedCheckboxError: 'Required to proceed',
            },
            paymentInstallments: {
                afterPayLabel: 'Or {0} payments of {1}{2}',
            },
        },
    },
};

export default translations;
